type DocumentNameUpdate =
  | {
      action: 'updateDocument';
      documentId: UUID;
      name: string;
    }
  | {
      action: 'updateLaunchName';
      templateIdToContractName: Record<UUID, string>;
    };

export function getDocumentNameUpdate({
  documentId,
  isNewFile,
  name,
  templateIdToContractName,
}: {
  documentId: UUID;
  isNewFile: boolean;
  name: string;
  templateIdToContractName: Record<UUID, string>;
}): DocumentNameUpdate {
  if (isNewFile) return { action: 'updateDocument', documentId, name };

  return {
    action: 'updateLaunchName',
    templateIdToContractName: {
      ...templateIdToContractName,
      [documentId]: name,
    },
  };
}
